module.exports = __webpack_public_path__ + "static/img/side_logo_max_zhxx.7e825911.png";